export default "__VITE_ASSET__pt7ITcr2__"